import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TaskResourceManager = React.lazy(
  () => import("../screean/task/taskResourceManager")
);
export function tareasResourceManager() {
  return (
    <Route
      path="/tareas-resource-manager"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <TaskResourceManager />
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
